"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationEvent = exports.DeviceCustomerAssignmentEvent = exports.DeviceRegistrationEvent = exports.BaseEvent = exports.SerialNumber = exports.Id = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const entity_1 = require("../../../entity");
const schema_1 = require("../../../schema");
const event_1 = require("../../device/capability/event");
exports.NAMESPACE = 'Culligan.Integration.Notification.Event';
const EXAMPLE_DEVICE_ID = '00000000-0000-0000-0000-000000000001';
exports.Id = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${exports.NAMESPACE}.Id`,
});
exports.SerialNumber = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${exports.NAMESPACE}.SerialNumber`,
    description: 'Manufacturing serial number of the device',
});
class BaseEvent extends effect_1.Schema.Class(`${exports.NAMESPACE}.BaseEvent`)({
    id: exports.Id,
    deviceSerialNumber: event_1.Id,
    time: effect_1.Schema.Number,
    version: effect_1.Schema.Number,
    ...entity_1.BaseTimestampedEntity.fields,
    deviceGroupCode: effect_1.Schema.String,
    detailUri: effect_1.Schema.String,
}) {
}
exports.BaseEvent = BaseEvent;
const createFields = (type, data) => ({
    type: effect_1.Schema.tag(type),
    data: effect_1.Schema.Struct(data),
});
class DeviceRegistrationEvent extends BaseEvent.extend(`${exports.NAMESPACE}.DeviceRegistrationEvent`)(createFields('device-registration-event', {
    deviceSerialNumber: event_1.Id,
    manufacturingSerialNumber: schema_1.PrintString,
    additionalSerialNumber: schema_1.PrintString,
}), {
    identifier: `${exports.NAMESPACE}.DeviceRegistrationEvent`,
    description: 'Device registration notification event',
}) {
    static example = new DeviceRegistrationEvent({
        id: '6a6b82',
        deviceSerialNumber: EXAMPLE_DEVICE_ID,
        time: 1714041159978,
        version: 1,
        createdAt: new Date('2024-03-06T09:40:00.000Z'),
        updatedAt: new Date('2024-03-06T09:40:00.000Z'),
        deviceGroupCode: 'some-group-code',
        detailUri: 'some-uri',
        data: {
            deviceSerialNumber: EXAMPLE_DEVICE_ID,
            manufacturingSerialNumber: 'serial-number',
            additionalSerialNumber: 'additional-serial-number',
        },
    });
}
exports.DeviceRegistrationEvent = DeviceRegistrationEvent;
DeviceRegistrationEvent;
class DeviceCustomerAssignmentEvent extends BaseEvent.extend(`${exports.NAMESPACE}.DeviceCustomerAssignmentEvent`)(createFields('device-customer-assignment-event', {
    deviceSerialNumber: event_1.Id,
    manufacturingSerialNumber: schema_1.PrintString,
    customerNumber: schema_1.PrintString,
}), {
    identifier: `${exports.NAMESPACE}.DeviceCustomerAssignmentEvent`,
    description: 'Device customer assignment notification event',
}) {
    static example = new DeviceCustomerAssignmentEvent({
        id: '6a6b82',
        deviceSerialNumber: EXAMPLE_DEVICE_ID,
        time: 1714041159978,
        version: 1,
        createdAt: new Date('2024-03-06T09:40:00.000Z'),
        updatedAt: new Date('2024-03-06T09:40:00.000Z'),
        deviceGroupCode: 'some-group-code',
        detailUri: 'some-uri',
        data: {
            deviceSerialNumber: EXAMPLE_DEVICE_ID,
            manufacturingSerialNumber: 'serial-number',
            customerNumber: 'customer-number',
        },
    });
}
exports.DeviceCustomerAssignmentEvent = DeviceCustomerAssignmentEvent;
DeviceCustomerAssignmentEvent;
exports.NotificationEvent = effect_1.Schema.Union(DeviceRegistrationEvent, DeviceCustomerAssignmentEvent).annotations({
    identifier: `${exports.NAMESPACE}.NotificationEvent`,
});
//# sourceMappingURL=event.js.map